/**
 * Get the value of a cookie in the browser.
 *
 * This does not work on the server.
 */
export const getCookie = (name: string): string | undefined => {
	const cookie = document.cookie.match(
		`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`
	);
	return cookie ? cookie.pop() : '';
};
